import React from 'react';
import { getTimezoneDiscrepancyMessage } from '../utils/helpers';

export default function TimezoneDiscrepancyMessage() {
  const message = getTimezoneDiscrepancyMessage(new Date().getTimezoneOffset());

  if (!message) {
    return null;
  }

  return (
    <p
      data-testid="timezone-discrepancy-message-text"
      className="vads-u-margin-top--0 vads-u-margin-bottom--3 vads-u-color--gray-medium"
    >
      {message}
    </p>
  );
}
